var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"teamMember"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.job))]),_vm._v(" "),_c('div',{staticClass:"teamMember__image",style:({backgroundImage: ("url(" + _vm.image + ")")})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6126292","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamMember.vue
// module id = null
// module chunks = 